export default "__VITE_ASSET__CEjlmyBz__"